import { ButtonProjection } from '@lib/sanity/types/common';
import Anchor from '@ui/Anchor/Anchor';
import { Button, buttonVariants } from '@ui/Button/Button';
import cn from '@utils/cn';
import { getUrlWithTrailingSlash } from '@utils/urls';
import { isButtonExist } from '@utils/validations';
import { VariantProps } from 'class-variance-authority';

type AnchorButtonProps = {
  button?: Omit<ButtonProjection, '_type'> & {
    variant?: VariantProps<typeof buttonVariants>['variant'];
    size?: VariantProps<typeof buttonVariants>['size'];
  };
  anchorClassName?: string;
  buttonClassName?: string;
};

export default function AnchorButton({ button, anchorClassName, buttonClassName }: AnchorButtonProps) {
  return (
    isButtonExist(button) && (
      <Button asChild className={cn('select-none', buttonClassName)} size={button.size} variant={button.variant}>
        <Anchor
          {...(button.eventTracking?.elementName && {
            'ga-element': button.eventTracking.elementName,
          })}
          {...(button.eventTracking?.dataSource && {
            'ga-source': button.eventTracking.dataSource,
          })}
          {...(button.eventTracking?.dataMedium && {
            'ga-medium': button.eventTracking.dataMedium,
          })}
          {...(button.eventTracking?.dataExperiment && {
            'ga-experiment': button.eventTracking.dataExperiment,
          })}
          {...(button.eventTracking?.dataVariant && {
            'ga-variant': button.eventTracking.dataVariant,
          })}
          aria-label={button.text?.value ?? ''}
          href={getUrlWithTrailingSlash(button.url)}
          className={anchorClassName}
        >
          {button.text?.value}
        </Anchor>
      </Button>
    )
  );
}
